// extracted by mini-css-extract-plugin
export var cardLayout = "_8n-1";
export var paginationContainer = "_8n-0";